import React, { startTransition } from "react";
import css from "./AdminSidebar.module.scss";
import { Avatar, NavLink, Text } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { InfoOutlined } from "@mui/icons-material";
import { TbSettings2, TbTargetArrow, TbUsers } from "react-icons/tb";
const AdminSidebar = ({ orgDetails }) => {
  const { pathname } = useLocation();
  const page = pathname.split("/");
  const navigate = useNavigate();
  const ORG = "/organization";

  // Helper function to navigate with startTransition
  const handleNavigate = (path) => {
    startTransition(() => {
      navigate(path);
    });
  };
  return (
    <div className={css.container}>
      <div className={css.profile}>
        <Avatar
          src={orgDetails?.photoUrl}
          alt="profile img"
          radius="xl"
          size={"70px"}
        />
        <Text fw={600} tt={"capitalize"}>
          {orgDetails?.legal_name}
        </Text>
      </div>
      <div className={css.menuWrapper}>
        <NavLink
          icon={<InfoOutlined size={16} />}
          className={css.item}
          label="General Info"
          onClick={() => handleNavigate(`${ORG}/general-info`)}
          active={page.includes("general-info")}
        />
        <NavLink
          icon={<TbTargetArrow size={16} />}
          className={css.item}
          label="Manage Goals"
          onClick={() => handleNavigate(`${ORG}/manage-goals`)}
          active={page.includes("manage-goals")}
        />
        <NavLink
          icon={<TbUsers size={16} />}
          className={css.item}
          label="Manage Users"
          onClick={() => handleNavigate(`${ORG}/manage-users`)}
          active={page.includes("manage-users")}
        />
        <NavLink
          icon={<TbSettings2 size={16} />}
          className={css.item}
          label="Settings"
          onClick={() => handleNavigate(`${ORG}/settings`)}
          active={page.includes("settings")}
        />
      </div>
    </div>
  );
};

export default AdminSidebar;
